<template>
  <div class="header">
    <div class="inner">
      <div class="field-logo">
        <h1 class="logo">
            <img alt="アイデア発想方法マンダラート発想" src="../assets/logo.svg" />
        </h1>
      </div>
      <div class="field-nav">
        <button @click="openModal('howto')" class="btn-link">使い方</button>
        <button class="btn-link" onclick="window.print();">印刷</button>
      </div>
    </div>
    <!-- 使い方Modal -->
    <Modal v-if="isShowModalHowto" @close="closeModal">
      <div class="modal-how">
        <div class="modal-how__list">
          <div class="modal-how__item">
            <h3 class="modal-how__ttl"><span class="modal-how__num">01</span>メインキーワードを入力</h3>
            <p class="modal-how__txt">中央のフォームにアイデアを検討したい”メインキーワード”を書き、 「次へ」ボタンをクリック</p>
             </div>
          <div class="modal-how__item">
            <h3 class="modal-how__ttl"><span class="modal-how__num">02</span>メインテーマから連想した単語を周囲8マス書いていきましょう</h3>
            <p class="modal-how__txt">次に、中央にあるブロックの周囲の8つのマスにメインテーマから連想した単語を書いていきます。<br>書く内容には細かいルールはありませんので、とにかくメインテーマを見て頭に直感的に浮かんだものをどんどん書いていきましょう。</p>
             </div>
          <div class="modal-how__item">
            <h3 class="modal-how__ttl"><span class="modal-how__num">03</span>マンダラートを展開しよう</h3>
            <p class="modal-how__txt">作成した8つのマスのうちの一つのキーワードからさらに8つのキーワードを展開しよう</p>
          </div>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/89O_uOdHCro" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <template slot="footer">
        <button class="btn">× close</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
  name: "Header",
  components: {
    //モーダルコンポーネント
    Modal
  },
  data() {
    return {
      //使い方モーダル表示の有無
      isShowModalHowto: false
    };
  },
  methods: {
    //モーダルを表示する
    openModal(btnType) {
      if (btnType === "howto") {
        //使い方ボタンを押された時の処理
        this.isShowModalHowto = true;
      }
    },
    //モーダルを非表示にする
    closeModal() {
      this.isShowModalHowto = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  background-color: #fff;
  width: 100%;
  height: 60px;
  top: 0;
  z-index: 1000;
  .inner {
    padding: 3px 2%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-content: space-around;
    align-items: center;
    .field-logo {
      width: 40%;
    }
    .field-nav {
      width: 60%;
      text-align: right;
      a {
        display: inline-block;
        margin-left: 2%;
        color: #495057;
      }
      .btn-link {
        background-color: transparent;
        border: none;
        cursor: pointer;
        outline: none;
        padding: 0;
        margin-left: 5%;
        appearance: none;
        color: #495057;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .logo {
    text-align: left;
    img {
      height: 25px;
    }
  }
}

.modal-how{
  &__list{
    text-align: center;
  }

  &__item{
    margin-bottom: 30px;
  }

  &__img{
    width: 100px;
  }

  &__ttl{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
  }

  &__num{
    display: block;
    font-size: 24px;
    margin-bottom: 5px;
  }

  &__txt{
    font-size: 13px;
    text-align: left;
  }

}

@media print{
  .header{
    display: none;
  }
}

iframe{
  max-width: 100%;
}

</style>
